module.exports = __webpack_public_path__ + "img/login_01.0ea5d240.jpg";